<template>
<div class="my-mileage-area">
      <h3 class="c-title-level3">마일리지 내역</h3>
      <div class="c-round-box">
        <div class="text-wrap">
          <p class="text">
            <strong>-마일리지 적립 기준 : </strong>
            월별 마감 후 페인트프로 인터넷 주문 매출금액의 0.15% 적립 / 매월 마감 시점에 해당 월 누적분 일괄 적립
          </p>
          <p class="text">
             <strong>-마일리지 지급 : </strong>
            상품권 지급 > 당 해 상반기/하반기 별 누적 기준 10만 포인트당 10만원 상품권 지급   
          </p>
          <p class="text">
             <strong>-지급일정 : </strong>
            당 해 추석 전:  상반기(1~6월) 누적분 지급 /  설 (구정) 전: 당 해 하반기(7~12월) 누적분 지급
          </p>
          <p class="text">
             <strong class="subject">※ 마일리지는 페인트프로를 통한 인터넷 주문 건에 한하여 적립되며, 상품권은 지급 기간에 일괄 발송됩니다.</strong>
          </p>
          <p class="text">
             <strong class="subject">※ 상품권 지급 후 해당 포인트는 자동 차감 처리 됩니다</strong>
          </p>
          <p class="text">
            <strong class="subject">※ 잔여 마일리지는 당해 년도 내에서만 유효하며, 다음 해(약년)로 이월되지 않습니다.</strong>
          </p>
        </div>
      </div>
     <div class="c-btn-area flex-ar mt24"></div>
     
      <div class="mileage-year-select">
        <label class="label">적립년도 선택</label>
        <div class="c-select type-medium">
          <select name="year" id="year"  v-model="searchParams.selectedYear"/>
        </div>
      </div>
       <div class="scroll-x">
        <div class="scroll-x-inner">
            <div class="c-table type-mileage">
            <table>
              <caption>
                개인정보에 관한 민원서비스 테이블
              </caption>
              <colgroup>
                <col style="width: 120px;">
                <col style="width: 220px;">
                <col style="width: 220px;">
                <col style="width: 220px;">
                <col style="width: 220px;">
              </colgroup>
              <thead>
                <tr>
                  <th class="ac">월별</th>
                  <th class="ac">매출금액<em class="vat-exclude">VAT 제외</em></th>
                  <th class="ac">인터넷주문금액<em class="vat-exclude">VAT 제외</em></th>
                  <th class="ac">마일리지 적립액</th>
                  <th class="ac">누적 마일리지</th>
                </tr>
              </thead>
              <tbody>
                  <template 
                    v-for="(item,idx) in list"
                    :key="idx" >                  
                  <tr v-if="item.month == 'first'" class="mileage-pay-row">
                      <td class="mileage-pay-title">상반기 지급</td>
                      <td class="ac"></td>
                      <td class="ac"></td>
                      <td class="ac">지급 : - {{ isLargeNumber(Math.round(item.firstSumSpendAmount)) }} </td>
                      <td class="ac">{{ isLargeNumber(Math.round(item.firstSumBalance)) }}</td>
                    </tr>
                    <tr v-else-if="item.month == 'second'" class="mileage-pay-row">
                      <td class="mileage-pay-title">하반기 지급</td>
                      <td class="ac"></td>
                      <td class="ac"></td>
                      <td class="ac">지급 : - {{ isLargeNumber(Math.round(item.firstSumSpendAmount)) }}</td>
                      <td class="ac">{{ isLargeNumber(Math.round(item.secondSumBalance)) }}</td>
                    </tr>
                    <tr v-else>
                      <td class="ac">
                        {{ item.month }}
                      </td>
                      <td class="ac">
                        {{ isLargeNumber(Math.round(item.totalOrderPrice)) }} 
                      </td >
                      <td  class="ac">
                        {{ isLargeNumber(Math.round(item.accrualOrderPrice) )}}
                      </td>
                      <td class="ac">
                        {{ isLargeNumber(Math.round(item.sumAccrualAmount) )}}
                      </td>
                      <td class="ac">
                        {{ isLargeNumber(Math.round(item.sumBalance) )}}
                      </td>
                    </tr>
                  </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
</template>
<script setup name="delivMngTab">
import { inject, onBeforeUnmount, onMounted, ref} from "vue";
import { api } from "@/plugins/api";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();

const url = inject("url_prefix");




const searchParams = ref({
  page: 1,
  limit: 20,
  selectedYear : '2026',
});


const pageData = ref(null);
const list = ref([]);
const mobileList = ref([]);
const scrollSensed = ref(false); // 스크롤 중복 감지를 막기 위한 변수입니다.


onMounted(() => {
  setYear();
  loadSearchData();
  window.addEventListener("scroll", onScrollEvent, true);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScrollEvent);
});

const setYear = () => {
    var crrenYear = new Date().getFullYear();
    var busiYearSelect = document.getElementById("year");

    for (let i = '2026'; i <= crrenYear; i++) {
      const option = document.createElement("option");
      option.value = i ;
      option.text = i + " 년";
      busiYearSelect.appendChild(option);
    }
}


const loadSearchData = async () => {
  const res = await api.post(`${url}/utility/userinfo/selectMileageList`, {
    ...searchParams.value,
  });

  const { resultCode } = res;
  if (resultCode !== 200) {
    return;
  }

  pageData.value = res.data;
  list.value = [...pageData.value.list];
  mobileList.value.push(...pageData.value.list);
};

const loadNextPage = () => {
  if (!pageData.value) {
    // 페이지 정보가 로드되지 않은 상태에서는 다음페이지를 로드하지 않습니다.
    return;
  }

  if (pageData.value.currPage >= pageData.value.totalPage) {
    return;
  }

  searchParams.value.page += 1;

  loadSearchData();
};

const isLargeNumber = (numStr) => {
  const numWithoutComma = numStr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return numWithoutComma;
};

const onScrollEvent = () => {
  if (scrollSensed.value) return;
  if (!isMobile.value) return;

  const scrollTop = Math.ceil(document.documentElement.scrollTop);
  const scrollHeight = document.documentElement.scrollHeight;
  const clientHeight = document.documentElement.clientHeight;

  const isBottom = scrollTop + clientHeight >= scrollHeight ? true : false;

  if (isBottom) {
    loadNextPage();

    scrollSensed.value = true;
    setTimeout(() => {
      scrollSensed.value = false;
    }, 50);
  }
};
</script>
<style scoped></style>
